import React from 'react';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';
import {
  NumberOfItemsInTable,
  NumberOfItemsInTableProps,
} from 'src/components/enterprise/Parents/NumberOfItemsInTable/NumberOfItemsInTable';

export type NumberOfParentAdminsProps = Omit<
  NumberOfItemsInTableProps,
  'suffix'
>;

export const NumberOfParentAdmins: React.FC<NumberOfParentAdminsProps> = ({
  totalResults,
  ...props
}) => {
  const noun = getSingularOrPlural(totalResults, 'admin');

  const suffix = `parent ${noun}`;

  return (
    <NumberOfItemsInTable
      {...props}
      totalResults={totalResults}
      suffix={suffix}
    />
  );
};
